
import { SEO } from '../../utils/seo';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import PricingCalculator from './components/PricingCalculator';
import DeliverablesBreakdown from './components/DeliverablesBreakdown';
import RateTable from './components/RateTable';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function TimberForestryPricingPage() {
  const scrollToCalculator = () => {
    const el = document.getElementById('calculator');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.warn('Element with id "calculator" not found.');
    }
  };

  return (
    <>
      <SEO
        title="Timber & Forestry Pricing | Instant Project Estimates"
        description="Estimate pricing for timber inventory, forest health, LiDAR surveys, and valuation services. Scalable per-acre pricing with real-time calculator."
        keywords="timber drone pricing, forestry survey cost, LiDAR forestry pricing, timber inventory cost estimate, forest health survey pricing"
      />
      <div className="min-h-screen bg-white">
        <Header />
        <HeroSection onScrollToCalculator={scrollToCalculator} />
        {/* Add an id to the calculator section so scroll works */}
        <section id="calculator">
          <PricingCalculator />
        </section>
        <DeliverablesBreakdown />
        <RateTable />
        <FaqSection />
        <CtaSection />
        <Footer />
      </div>
    </>
  );
}
